import { useQuery } from "@tanstack/react-query";
import { getCourseList } from "../services/dashboardService";

const useCourseList = (targetJob) => {
  return useQuery({
    queryKey: ["courseList", targetJob], // Ensure different jobs fetch fresh data
    queryFn: () => getCourseList(targetJob),
    enabled: !!targetJob, // Ensures it runs only when targetJob is available
    staleTime: Infinity, // Keeps data fresh until manually invalidated
    cacheTime: Infinity, // Persist data even if no components are using it
    onError: (error) => {
      console.error("Error:", error.response?.data || error.message);
    },
  });
};

export default useCourseList;
